import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarComponent } from './snackbar.component';
import { WmProgressbarModule } from '../progressbar/index';
import { WmTransitionModule } from '../transition/index';
import { WmCardModule } from '../card/index';
import { SnackbarContainerComponent } from './snackbar-container/snackbar-container.component';

@NgModule({
	declarations: [SnackbarComponent, SnackbarContainerComponent],
	imports: [CommonModule, WmTransitionModule, WmProgressbarModule, WmCardModule],
	exports: [SnackbarComponent, SnackbarContainerComponent]
})
export class WmSnackbarModule {}
